'use client';

import { memo as Memo, Fragment } from 'react';

//* HOC's
import withLanguageContext from '@context/consumerHOC/LanguageConsumer';
import withUIContext from '@/context/consumerHOC/UIConsumer';

//* Components
import Page from '@components/global/Page';
import Text from '@components/global/Text';
import CustomLink from '@/components/global/CustomLink';
import HTMLContainer from '@components/global/HTMLContainer';

//* Styles
import LegalStyle from '@/styles/pages/LegalStyle';

const Legal = Memo(({ pageData, translate, globalData }) => {
	return (
		<Page>
			{pageData ? (
				<LegalStyle className={'legal'}>
					<HTMLContainer>
						<div className={`section-item legalSections`}>
							<Text
								tag={'h1'}
								className={`h6 font-poppins font-semi-bold title`}>
								{pageData.terms_of_use.title}
							</Text>

							{pageData.terms_of_use.items.map((item, ind) => {
								return (
									<Fragment key={ind}>
										<Text className={`p-m font-poppins uppercase font-medium subtitle`}>{ind + 1 + '. ' + item.title}</Text>

										<Text className={`p-m font-poppins font-light description`}>
											<span dangerouslySetInnerHTML={{ __html: item.description }} />
										</Text>
									</Fragment>
								);
							})}

							<div className={'details'}>
								<Text
									className={`p-m font-poppins font-medium subtitle`}
									text='companyDetails'
								/>

								<div className={'email'}>
									<Text className={`p-m font-poppins font-light info`}>
										<Text
											tag={'span'}
											className='font-medium'>
											{translate('mail')}:
										</Text>

										<CustomLink
											external
											url={`mailto:${globalData?.contact_information?.mail}`}>
											{globalData?.contact_information?.mail}
										</CustomLink>
									</Text>
								</div>

								<div>
									<Text className={`p-m font-poppins font-light info`}>
										<Text
											tag={'span'}
											className='font-medium'>
											{translate('Registered')}:
										</Text>

										<CustomLink
											external
											url={`${globalData?.contact_information?.addresses[0]?.link}`}>
											{globalData?.contact_information?.addresses[0]?.address}
										</CustomLink>
									</Text>
								</div>
							</div>
						</div>

						<div className={`section-item legalSections`}>
							<Text
								tag={'h4'}
								className={`font-poppins font-semi-bold title`}>
								{pageData.privacy_policy.title}
							</Text>

							{pageData.privacy_policy.items.map((item, ind) => {
								return (
									<Fragment key={ind}>
										<Text className={`p-m font-poppins uppercase font-medium subtitle`}>{ind + 1 + '. ' + item.title}</Text>

										<Text className={`p-m font-poppins font-light description`}>
											<span dangerouslySetInnerHTML={{ __html: item.description }} />
										</Text>
									</Fragment>
								);
							})}
						</div>
					</HTMLContainer>
				</LegalStyle>
			) : null}
		</Page>
	);
});

export default withLanguageContext(withUIContext(Legal, ['globalData']), ['translate']);
